<template>
  <IconWrapper name="cross" :color="color" fillMode="stroke">
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :style="rotate ? `transform: rotate(${rotate}deg);` : undefined"
    >
      <path
        d="M14.1196 12.6464L13.766 13L14.1196 13.3535L17.8024 17.0364C18.014 17.2479 18.014 17.5908 17.8024 17.8024C17.5909 18.0139 17.2479 18.0139 17.0364 17.8024L13.3536 14.1195L13 13.766L12.6464 14.1195L8.9636 17.8024C8.75205 18.0139 8.40911 18.0139 8.19757 17.8024C7.98602 17.5908 7.98602 17.2479 8.19757 17.0364L11.8804 13.3535L12.234 13L11.8804 12.6464L8.19757 8.96356C7.98603 8.75203 7.98603 8.40907 8.19757 8.19753C8.40911 7.98599 8.75206 7.98599 8.9636 8.19753L12.6464 11.8804L13 12.2339L13.3536 11.8804L17.0364 8.19753C17.2479 7.98599 17.5909 7.98599 17.8024 8.19753C18.014 8.40907 18.014 8.75203 17.8024 8.96356L14.1196 12.6464Z"
        fill="#1B1B1E"
        stroke="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  rotate?: number
}>()
</script>
